// Locale-aware "5 minutes ago" via Intl.RelativeTimeFormat.
//
// Replaces hand-built English strings ("5m ago", "just now") so the
// output follows the active i18n language (nl / fr once translated).

const UNITS: ReadonlyArray<[Intl.RelativeTimeFormatUnit, number]> = [
  ["second", 60],
  ["minute", 60],
  ["hour", 24],
  ["day", 7],
  ["week", 4.345],
  ["month", 12],
  ["year", Number.POSITIVE_INFINITY],
];

/**
 * Format ``iso`` relative to ``now`` in ``locale`` (e.g. "3 hours
 * ago", "il y a 3 heures"). Falls back to the raw string when the
 * date can't be parsed.
 */
export function formatRelativeTime(
  iso: string,
  locale: string,
  now: number = Date.now(),
): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return iso;
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  // Negative = past. Clamp tiny clock skew into the past.
  let value = Math.min(0, (then - now) / 1000);
  for (const [unit, size] of UNITS) {
    if (Math.abs(value) < size) {
      return rtf.format(Math.round(value), unit);
    }
    value /= size;
  }
  return iso;
}
